module.exports = __webpack_public_path__ + "static/media/coffee-promo-mb-en.c04ce72c.jpg";